import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const walkTogetherTourData: NavItem[] = [
  {
    label: 'Hero',
    to: '/pages/walkTogetherTour/hero'
  },
  {
    label: 'Vision-top',
    to: '/pages/walkTogetherTour/visionTop'
  },
  {
    label: 'Vision-bottom',
    to: '/pages/walkTogetherTour/visionBottom'
  },
  {
    label: 'Report',
    to: '/pages/walkTogetherTour/report'
  },
  {
    label: 'Teams',
    to: '/pages/walkTogetherTour/teams'
  }
];
